import apiClient from '@/api/apiClient.js';

export default {
  namespaced: true,
  state: {
    schema: {},
  },

  getters: {
    schema(state) {
      return state.schema;
    },
  },

  mutations: {
    insertSchema(state, schema) {
      state.schema = schema;
    },
  },

  actions: {
    async loadSchema({ commit }) {
      try {
        const res = await apiClient.proSignUpSchema();
        const schema = res.data;

        const resCat1 = await apiClient.catMentalCareers();
        const catMentalCareers = resCat1.data.data;

        const resCat2 = await apiClient.catStatusLicenses();
        const catStatusLicenses = resCat2.data.data;

        schema.schemaForm.group2.schema.mental_careers_mental_careers_id.items = catMentalCareers;
        schema.schemaForm.group2.schema.status_licenses_status_licenses_id.items =
          catStatusLicenses;
        commit('insertSchema', schema);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
  },
};
